
import Vue from "vue";
import NewQuoteForm from "../components/NewQuoteForm.vue";

export default Vue.extend({
  name: "AboutView",

  components: { NewQuoteForm },
  data() {
    return {
      showSuccessSnackbar: false,
      loading: false,
      errorMessage: "",
      isSaveEnabled: false,
      aboutContent: [
        {
          title: "Our Journey",
          content:
            "Our journey began right here in the heart of Hawke's Bay. Fueled by a personal experience of the challenges that come with house moving, we embarked on a mission to provide a reliable and cost-effective solution for individuals and families looking to transition to their new homes seamlessly. It was during this time that we realized the inconvenience caused by exorbitant pricing from existing service providers. The need for a more compassionate, customer-centric, and budget-friendly moving service became evident. As we pondered over the issue, an idea was born—to establish Budget Packers and Movers, a venture that would redefine the moving experience for everyone.",
        },
        {
          title: "Catering to Unique Needs",
          content:
            "Our humble beginnings were driven by a genuine intention to be a helping hand for our community members. We recognized the challenges faced by the elderly and those who were physically unable to manage the complexities of moving on their own. This realization fueled our determination to bridge the gap and provide tailored moving solutions that cater to individual needs. At Budget Packers and Movers, our core motivation is rooted in the philosophy of delivering the best service at rates that don't burden your pocket. We believe that quality moving services should be accessible to all, regardless of their budget constraints. Our aim is not only to relocate your belongings but to provide a smooth transition that eases the stress associated with moving.",
        },
        {
          title: "Our Core Motivation",
          content:
            "Customer satisfaction is the cornerstone of our business. We understand that moving is not just about transporting possessions; it's about moving memories, hopes, and dreams. Our dedicated team is committed to understanding your unique requirements, offering personalized solutions, and executing each move with the utmost care and professionalism. As we continue to grow, our focus remains unwavering—to be the preferred choice for those seeking dependable, affordable, and customer-centric moving services. We take immense pride in being a part of the Hawkes Bay community and contributing to its growth by offering reliable solutions that alleviate the challenges of moving.",
        },
        {
          title: "Experience the Difference",
          content:
            "Whether you're a family transitioning to a new home or an elderly individual seeking assistance, Budget Packers and Movers is here to make your moving experience a positive one. From our origins in Hawkes Bay to our commitment to service excellence, every step we take reflects our dedication to being your trusted partner on your journey. Experience the difference with Budget Packers & Movers—a moving service that goes beyond the ordinary to make your transition extraordinary.",
        },
      ],
    };
  },
  methods: {
    async submitQuoteRequest(): Promise<void> {
      if (this.$refs.newQuoteForm) {
        this.loading = true;
        const quoteForm = this.$refs.newQuoteForm as InstanceType<
          typeof NewQuoteForm
        >;

        await quoteForm.submitQuoteRequest();
        this.loading = false;
      }
    },
    onErrorMessageChanged(value: string) {
      this.errorMessage = value;
    },
    onSaveEnableDisable(value: boolean) {
      this.isSaveEnabled = value;
    },
    onQuoteSubmitted() {
      this.showSuccessSnackbar = true;
    },
  },
});
